import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { HeadlineOverlay, HeadlineOverlayVariation } from '@/store/videoFeatures/types/headline-overlay';
import { HeadlineABOrderCard } from './HeadlineABOrderCard';
import { DndContext, closestCenter, useSensor, useSensors, PointerSensor, DragEndEvent } from '@dnd-kit/core';
import { SortableContext, arrayMove, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { toast } from 'sonner';

interface HeadlineABOrderStepProps {
  variations: HeadlineOverlayVariation[];
  onUpdateConfig: (updates: Partial<HeadlineOverlay['abTestConfig']>) => void;
}

export function HeadlineABOrderStep({ variations, onUpdateConfig }: HeadlineABOrderStepProps) {
  useLanguage();
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: { distance: 5 },
    })
  );

  const handleDragEnd = (event: DragEndEvent) => {
    const { active, over } = event;
    
    if (over && active.id !== over.id) {
      const oldIndex = variations.findIndex(v => v.id === active.id);
      const newIndex = variations.findIndex(v => v.id === over.id);
      const reorderedVariations = arrayMove(variations, oldIndex, newIndex);
      onUpdateConfig({ variations: reorderedVariations });
      toast.success(translateInterfaceText("Ordem atualizada"));
    }
  };

  return (
    <div className="space-y-4">
      {/* Sortable List */}
      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragEnd={handleDragEnd}
      >
        <SortableContext
          items={variations.map(v => v.id)}
          strategy={verticalListSortingStrategy}
        >
          <div className="space-y-4">
            {variations.map((variation, index) => (
              <HeadlineABOrderCard
                key={variation.id}
                variation={variation}
                orderIndex={index}
                isPrimary={index === 0}
              />
            ))}
          </div>
        </SortableContext>
      </DndContext>
    </div>
  );
}
